//****************************************
// Scale Legend Prototype
// DOM Registration: No
// National Instruments Copyright 2015
//****************************************

/**
## ni-scale-legend

> A custom element that provides a scale legend.

Use it to visualize and change the axis modes of a graph, chart or intensity graph element.

It provides a list with all the axes of the graphs.

Each axis in the list has two buttons - one to turn on/off the autoscaling for that axis and
the other one sets the scale range to the data range (without changing the autoScale mode)

Example:
```html
<ni-cartesian-graph graph-ref="g1" value="[[2, 3, 5, 7, 11, 13, 17, 19],
                          [0, 1, 1, 2, 3, 5, 8, 13]]">
    <ni-cartesian-axis show label="Index" axis-position="bottom"></ni-cartesian-axis>
    <ni-cartesian-axis show label="Value" axis-position="left"></ni-cartesian-axis>
    <ni-cartesian-plot show label="Prime Numbers">
        <ni-cartesian-plot-renderer line-width="2" line-stroke="red">
        </ni-cartesian-plot-renderer>
    </ni-cartesian-plot>
    <ni-cartesian-plot show label="Fibonacci Numbers">
        <ni-cartesian-plot-renderer line-width="2" line-stroke="blue">
        </ni-cartesian-plot-renderer>
    </ni-cartesian-plot>
</ni-cartesian-graph>

<ni-scale-legend graph-ref="g1" mode="pan"></ni-scale-legend>
```
*/

(function() {
    'use strict';

    var $ = NationalInstruments.Globals.jQuery;

    class ScaleLegend extends NationalInstruments.HtmlVI.Elements.GraphLegend {
        created() {
            super.created();

            this.tbl = undefined;
            this.nScales = 0;
            this.currentExpander = null;
            this.helpers = new NationalInstruments.HtmlVI.Elements.ScaleLegendHelpers();
            this.uihelpers = new NationalInstruments.HtmlVI.Elements.LegendHelpers(this.helpers, null);
        };

        scaleAdded(scale) {
            var index = this.helpers.scaleToIndex(scale),
                alreadyAdded = index < this.nScales;
            if (!alreadyAdded) {
                this.createRow(this.tbl, this.nScales);
                this.helpers.addScale(this.nScales);
                this.nScales++;
            }
        };

        scaleRemoved(scale) {
            var tr, td, text, i, j, index, toRemove = null;
            j = 0;
            for (i = 0; i < this.tbl.childNodes.length; i++) {
                if (this.tbl.childNodes[i].localName === 'tr') {
                    tr = this.tbl.childNodes[i];
                    td = tr.childNodes[0];
                    text = td.innerText;
                    if (text === scale.label) {
                        toRemove = tr;
                        index = j;
                        break;
                    }
                }

                j++;
            }

            if (toRemove !== null) {
                this.tbl.removeChild(toRemove);
                this.helpers.clearScale(index);
            }

            this.nScales--;
        };

        createRows() {
            var i;
            for (i = 0; i < this.nScales; i++) {
                this.createRow(this.tbl, i);
            }
        };

        removeRows() {
            var i;
            for (i = this.nScales - 1; i >= 0; i--) {
                var scale = this.helpers.getScale(i);
                if (scale !== null) {
                    this.scaleRemoved(scale);
                }
            }
        };

        attachToGraph(graphElement) {
            this.detachFromGraph();
            if (graphElement && graphElement.isReady) {
                this.helpers.graph = graphElement;
                graphElement.registerScaleLegend(this);
            }
        };

        detachFromGraph() {
            this.helpers.graph = null;
            this.helpers.clearScale();
            this.removeRows();
        };

        attached() {
            super.attached();
            var childElement = document.createElement('div');
            var that = this;

            this.helpers.graph = this.findGraph();
            this.helpers.isInEditMode = this.isInEditMode;
            childElement.style.width = '100%';
            childElement.style.height = '100%';
            this.appendChild(childElement);
            this.tbl = document.createElement('table');
            this.tbl.className = 'ni-scale-legend-box';
            childElement.appendChild(this.tbl);
            this.addEventListener('ni-cartesian-axis-attached', function(evt) {
                var scale = evt.detail.originalSource;
                scale.initialAutoscale = scale.autoScale;
                that.scaleAdded(scale);
            });
            this.addEventListener('ni-cartesian-axis-detached', function(evt) {
                that.scaleRemoved(evt.detail.originalSource);
            });
            this.addEventListener('ni-axis-changed', function(evt) {
                var scale = evt.detail.originalSource;
                var index = that.helpers.scaleToIndex(scale);
                var labels = $(this.tbl).find('.ni-row-title');
                var lockButtons = $(this.tbl).find('.ni-lock-button');
                $(labels[index]).first().text(scale.label);
                this.setLockBackground(lockButtons[index], false, index);
            });
            var graph = this.findGraph();

            if (graph !== null) {
                this.attachToGraph(graph);
            }
        };

        createRow(tbl, index) {
            var that = this;
            var tr, td1, td2, td3, span, p, btnLock, btnResetOffset;

            tr = document.createElement('tr');
            tbl.appendChild(tr);
            td1 = document.createElement('td');
            td1.className = 'ni-row-title-box';
            tr.appendChild(td1);
            span = document.createElement('span');
            span.className = 'ni-row-title';
            td1.appendChild(span);
            var scaleName = that.helpers.getState('name', index);
            p = document.createTextNode(scaleName);
            span.appendChild(p);

            td2 = document.createElement('td');
            td2.className = 'ni-lock-box';
            tr.appendChild(td2);
            btnLock = this.uihelpers.createJQXButton('ni-lock-button ni-button', true);
            btnLock.disabled = !this.helpers.getState('canLock', index) || that.isDisabledOrInEditMode();
            $(btnLock).on('click', function() {
                that.helpers.handleClick('lock', index);
                that.setLockBackground(btnLock, false, index);
            });
            that.setLockBackground(btnLock, true, index);
            td2.appendChild(btnLock);

            td3 = document.createElement('td');
            td3.className = 'ni-reset-offset-box';
            tr.appendChild(td3);
            btnResetOffset = this.uihelpers.createJQXButton('ni-reset-offset-icon ni-button', false);
            btnResetOffset.disabled = that.isDisabledOrInEditMode();
            $(btnResetOffset).on('click', function() {
                that.helpers.handleClick('resetOffset', index);
                that.setLockBackground(btnLock, false, index);
            });
            td3.appendChild(btnResetOffset);
            this.applyFont();
        };

        setLockBackground(btn, first, index) {
            var state = this.helpers.getState('lock', index);
            if (state !== undefined) {
                if (first === true) {
                    btn.checked = state;
                }

                if (state === true) {
                    btn.classList.remove('ni-locked-icon');
                    btn.classList.add('ni-unlocked-icon');
                } else {
                    btn.classList.remove('ni-unlocked-icon');
                    btn.classList.add('ni-locked-icon');
                }
            }
        };

        setFont(fontSize, fontFamily, fontWeight, fontStyle, textDecoration) {
            var childElement = this.firstElementChild,
                thisRef = $(this),
                jqrefItemTitle = $(childElement).find(' .ni-row-title');

            thisRef.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });

            jqrefItemTitle.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
        };

        applyFont() {
            var childElement = this.firstElementChild,
                jqrefItemTitle = $(childElement).find(' .ni-row-title');

            var fontSize = $(this).css('font-size');
            var fontFamily = $(this).css('font-family');
            var fontWeight = $(this).css('font-weight');
            var fontStyle = $(this).css('font-style');

            jqrefItemTitle.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
        };

        updateDisabledState() {
            let that = this;
            $(this.tbl).find('.ni-lock-button').each(function() {
                this.disabled = that.isDisabledOrInEditMode();
            });
            $(this.tbl).find('.ni-reset-offset-icon').each(function() {
                this.disabled = that.isDisabledOrInEditMode();
            });
        }

        propertyChangedHandler(propertyName, oldValue, newValue) {
            super.propertyChangedHandler(propertyName, oldValue, newValue);

            switch (propertyName) {
                case 'graphRef':
                    // TODO: add a scale-legend-detached event for parent graph
                    this.helpers.graph.scaleLegend = null;
                    var graphElement = this.findGraph();
                    this.attachToGraph(graphElement);
                    break;
                case 'disabled':
                case 'isInEditMode':
                    // this changes once after the element is created
                    this.helpers.isInEditMode = this.isInEditMode;
                    this.updateDisabledState();
                    break;
                default:
                    break;
            }
        };
    };

    JQX('ni-scale-legend', ScaleLegend);
}());
